module.exports = __webpack_public_path__ + "media/images/icons/correct-icon-8a74558356d077ec008d1cdf36d9c1b7.svg";